import { patchRequest } from 'services/requests';

const services = {
    updateFeedback: (id, body) => patchRequest(`/feedback/${id}`, body),
};

export default services;
